import styled from "styled-components";
import globalStyles from "../../constants/globalStyles/theme.json";

const { spacing, breakpoints } = globalStyles;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.space24};
`;

export const ContainerOne = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing.space32};
  margin-bottom: ${spacing.space64};

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    gap: ${spacing.space16};
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledTextContent = styled.p``;

export const StyledContactContent = styled.p`
  margin-bottom: -${spacing.space2};
`;

export const ImageContainer = styled.div`
  display: flex;
`;

export const ContainerTwo = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${spacing.space32};
  margin-bottom: ${spacing.space64};

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    gap: ${spacing.space16};
  }
`;

export const CollidedImageContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 75%;
  margin: 0 auto;
  margin-bottom: calc(${spacing.space96} * 2);

  .rightImage {
    position: relative;
    top: 150px;
    left: -10px;
    z-index: 1;
  }

  @media (max-width: ${breakpoints.m}) {
    width: 100%;
  }
`;
